import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "./App.css";

import Login from "./components/user/Login";
import Logout from "./components/user/Logout";
import Register from "./components/user/Register.js";
import RegisterClient from "./components/user/RegisterClient.js";
import UserList from "./components/user/user";

import "./assets/styles/main.css";
import "./assets/styles/responsive.css";

import Page404 from "./components/404/404Page";
import Dashboard from "./components/Dashboard/Graph/Dashboard";
import DetailStaff from "./components/user/detailsStaff";

import Designation from "./components/designation/designation";
import DetailDesignation from "./components/designation/detailDesignation";
import UpdateDesignation from "./components/designation/updateDesignation";

import Main from "./components/layouts/Main";

import WelcomePage from "./components/UI/welcomePage";
import Department from "./components/department/Department.js";
import DetailDepartment from "./components/department/DetailsDepartment";
import CalculatePayroll from "./components/payroll/CalculatePayroll";
import AddPermission from "./components/role/AddPermission";
import DetailRole from "./components/role/DetailsRole";
import RoleList from "./components/role/role";
import InvoiceSetting from "./components/settings/invoiceSetting";
import OfficeAreaSetting from "./components/settings/officeAreaSetting.js";
import SalaryComponents from "./components/settings/salaryComponents.js";
import SalaryTemplates from "./components/settings/salaryTemplates.js";
import GetAllUsers from "./components/user/GetAllUser";

import Attendance from "./components/attendance/AddAttendance";
import UserAttendance from "./components/attendance/UserAttendance";
import EmploymentStatus from "./components/employmentStatus/EmploymentStatus";
import DetailEmploymentStatus from "./components/employmentStatus/EmploymentStatusDetails";
import DetailLeave from "./components/leave/DetailLeave";
import GetAllLeaves from "./components/leave/GetAllLeaves";
import Leave from "./components/leave/Leave";
import PayslipList from "./components/payroll/PayslipList";
import Shift from "./components/shift/Shift";
import DetailShift from "./components/shift/ShiftDetails";

import Account from "./components/account/account";
import BalanceSheet from "./components/account/balanceSheet";
import DetailAccount from "./components/account/detailAccount";
import IncomeStatement from "./components/account/incomeStatement";
import TrialBalance from "./components/account/trialBalance";

import UserPrivateRoute from "./components/PrivateRoutes/UserPrivateRoute";
import Announcement from "./components/announcement/Announcement";
import DetailAnnouncement from "./components/announcement/AnnouncementDetails";
import AddAward from "./components/award/AddAward";
import DetailAward from "./components/award/DetailsAward";
import GetAllAward from "./components/award/GetAllAward";
import KanbanBoard2 from "./components/kanbanBoard/KanbanBoard2";
import UserLeave from "./components/leave/UserLeave";
import DetailLeavePolicy from "./components/leavePolicy/DetailsLeavePolicy";
import LeavePolicy from "./components/leavePolicy/LeavePolicy";
import DetailPayslip from "./components/payroll/PayslipDetail";
import AddProject from "./components/project/AddProject";
import UpdateProject from "./components/project/UpdateProject";
import UpdateStatus from "./components/project/UpdateStatus";
import UpdateMilestone from "./components/project/milestone/UpdateMilestone";
import Milestone from "./components/project/milestone/milestone";
import Project from "./components/project/project";
import UpdateTaskPriority from "./components/project/taskPriority/UpdateTaskPriority";
import TaskPriority from "./components/project/taskPriority/taskPriority";
import UpdateTaskStatus from "./components/project/taskStatus/UpdateTaskStatus";
import TaskStatus from "./components/project/taskStatus/taskStatus";
import Task from "./components/project/tasks/tasks";
import DetailProjectTeam from "./components/project/team/DetailProjectTeam";
import ProjectTeam from "./components/project/team/ProjectTeam";
import DetailPublicHoliday from "./components/publicHoliday/DetailsPublicHoliday";
import PublicHoliday from "./components/publicHoliday/PublicHoliday";
import AddTransaction from "./components/transaction/AddTransaction";
import DetailTransaction from "./components/transaction/detailTransaction";
import Transaction from "./components/transaction/transaction";
import DetailWeeklyHoliday from "./components/weeklyHoliday/DetailsWeeklyHoliday";
import WeeklyHoliday from "./components/weeklyHoliday/WeeklyHoliday";

// import AddExpense from "./components/expense/AddExpense";
import GetTotalAttendence from "./components/attendance/totalUserAttendence.js";
import DetailExpense from "./components/expense/DetailExpense.js";
import Expense from "./components/expense/Expense.js";
import GetAllExpenses from "./components/expense/GetAllExpenses.js";
import UserExpense from "./components/expense/UserExpense.js";
import LinkCompany from "./components/user/linkCompany.js";
import LinkUser from "./components/user/linkUser.js";
import GetTotalSalary from "./components/user/totalSalary.js";

import ContractDetails from "./components/ContractDetails/ContractDetails.js";
import AssignAssetPopup from "./components/UI/PopUp/assignAssetPopup.js";
import AssetsStatus from "./components/assets/assetStatus.js";
import MyAssets from "./components/assets/myAssets.js";
import NewAssets from "./components/assets/newAssets.js";
import AddUserAttendance from "./components/attendance/AddUserAttendance.js";
import DetailAttendance from "./components/attendance/DetailAttendance.js";
import DayPartSchedule from "./components/dayPart/dayPart.js";
import DetailDayHours from "./components/dayPart/detailsDayHours.js";
import DocumentList from "./components/document/documentList.js";
import FileViewer from "./components/document/fileView.js";
import FolderContents from "./components/document/folderContent.js";
import FolderManager from "./components/document/folderManager.js";
import UpdateDocument from "./components/document/updateDocument.js";
import UploadDocuments from "./components/document/uploadDocument.js";
import UserDocument from "./components/document/userDocument.js";
import UserDocumentList from "./components/document/userDocumentList.js";
import EmailConfiguration from "./components/emailConfig/emailConfig.js";
import ExpenseProject from "./components/expenseProject/expenseProject.js";
import PrivacyPolicy from "./components/general/privacyPolicy.js";
import LeaveContradiction from "./components/leave/contradiction.js";
import AllocatedLeave from "./components/leavePolicy/allocatedLeave.js";
import Loan from "./components/loan/loan.js";
import NoticePeriodMaster from "./components/masters/NoticeMater.js";
import RateMaster from "./components/masters/RateMaster.js";
import ApproveReasonMaster from "./components/masters/approveReason.js";
import CategoryMaster from "./components/masters/category.js";
import ContractTypeMaster from "./components/masters/contractType.js";
import CountryMaster from "./components/masters/country.js";
import CountryOfIssueMaster from "./components/masters/countryOfIssue.js";
import CurrencyMaster from "./components/masters/currencyMaster.js";
import DocumentTypeMaster from "./components/masters/documentType.js";
import GenderMaster from "./components/masters/genderMaster.js";
import LunchHoursMaster from "./components/masters/lunchHours.js";
import ShowPayByMaster from "./components/masters/payMaster.js";
import PaymentTypeMaster from "./components/masters/paymentType.js";
import PlaceOfWorkMaster from "./components/masters/placeOfWork.js";
import RejectReasonMaster from "./components/masters/rejectReason.js";
import RelationshipMaster from "./components/masters/relationShipMaster.js";
import SalutationMaster from "./components/masters/salutations.js";
import StateMaster from "./components/masters/state.js";
import SubCategoryMaster from "./components/masters/subCategory.js";
import TeamsTypeMaster from "./components/masters/teamsType.js";
import TerminationReasonMaster from "./components/masters/terminationReason.js";
import DetailOverTime from "./components/overtime/DetailOverTime.js";
import OvertimeData from "./components/overtime/getOvertime.js";
import LogOvertime from "./components/overtime/overTime.js";
import UploadPaySlip from "./components/payroll/uploadPaySlip.js";
import MyTask from "./components/project/MyTask.js";
import WorkPlaceArea from "./components/settings/workPlaceAreaSetting.js";
import TerminationForm from "./components/termination/termination.js";
import ChangePassword from "./components/user/changePassword.js";
import ProfileDelete from "./components/user/deleteProfile.js";
import RemoveBiometric from "./components/user/removeBiometric.js";
import ResetPassword from "./components/user/resetPassword.js";
import CompanyDetails from "./components/settings/companyDetail.js";



function App() {
  return (
    <div className="App container-fluid">
      <ToastContainer
        position="bottom-left"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <BrowserRouter>
        {/* <TestComp/> */}
        <Main>
          <Routes>
            <Route path="/" element={<WelcomePage />} />
            <Route path="/admin/dashboard" element={<Dashboard />}></Route>
            <Route path="/admin" element={<Dashboard />} />
            <Route path="*" element={<Page404 />} />
            <Route path="/admin/changePassword" element={<ChangePassword />}></Route>
            <Route path="/admin/resetPassword" element={<ResetPassword />}></Route>
            <Route path="/admin/termination" element={<TerminationForm />}></Route>
            <Route path="/admin/overtime" element={<LogOvertime />}></Route>
            <Route path="/admin/getOvertime" element={<OvertimeData />}></Route>
            <Route path="/admin/overtime/:id" element={<DetailOverTime />} />
            <Route path="/admin/expenseProject" element={<ExpenseProject />}></Route>
            <Route path="/admin/state" element={<StateMaster />}></Route>
            <Route path="/admin/category" element={<CategoryMaster />}></Route>
            <Route path="/admin/paymentType" element={<PaymentTypeMaster />}></Route>
            <Route path="/admin/currency" element={<CurrencyMaster />}></Route>
            <Route path="/admin/rate" element={<RateMaster />}></Route>
            <Route path="/admin/showPay" element={<ShowPayByMaster />}></Route>
            <Route path="/admin/rejectReason" element={<RejectReasonMaster />}></Route>
            <Route path="/admin/approveReason" element={<ApproveReasonMaster />}></Route>
            <Route path="/admin/documentType" element={<DocumentTypeMaster />}></Route>
            <Route path="/admin/terminationReason" element={<TerminationReasonMaster />}></Route>
            <Route path="/admin/noticePeriod" element={<NoticePeriodMaster />}></Route>
            <Route path="/admin/lunchHours" element={<LunchHoursMaster />}></Route>
            <Route path="/admin/relationShip" element={<RelationshipMaster />}></Route>
            <Route path="/admin/gender" element={<GenderMaster />}></Route>
            <Route path="/admin/salutation" element={<SalutationMaster />}></Route>
            <Route path="/admin/countryOfIssue" element={<CountryOfIssueMaster />}></Route>
            <Route path="/admin/teamsType" element={<TeamsTypeMaster />}></Route>
            <Route path="/admin/contractType" element={<ContractTypeMaster />}></Route>
            <Route path="/admin/contractDetails" element={<ContractDetails />}></Route>
            <Route path="/admin/placeOfWork" element={<PlaceOfWorkMaster />}></Route>
            <Route path="/admin/placeOfWork/:id" element={<WorkPlaceArea />}></Route>
            <Route path="/admin/subCategory" element={<SubCategoryMaster />}></Route>
            <Route path="/admin/country" element={<CountryMaster />}></Route>
            <Route path="/admin/loan" element={<Loan />}></Route>
            <Route path="/admin/uploadPaySlip" element={<UploadPaySlip />}></Route>

            <Route path="/admin/auth/login" exact element={<Login />} />
            <Route path="/admin/LinkUser" exact element={<LinkUser />} />
            <Route path="/admin/LinkCompany" exact element={<LinkCompany />} />
            <Route path="/admin/removeBiometric" exact element={<RemoveBiometric />} />

            <Route path="/admin/ProfileDelete" exact element={<ProfileDelete />} />
            <Route path="/admin/DocumentList" exact element={<DocumentList />} />
            <Route path="/admin/FolderManager" exact element={<FolderManager />} />
            <Route path="/admin/folder/:id" element={<FolderContents />} />
            <Route path="/admin/file-viewer" element={<FileViewer />} />

            <Route path="/admin/auth/logout" exact element={<Logout />} />
            <Route path="/auth/register" exact element={<Register />} />
            <Route path="/admin/emailConfig" exact element={<EmailConfiguration />} />
            <Route path="/auth/registerClient" exact element={<RegisterClient />} />

            <Route element={<UserPrivateRoute permission={"create-user"} />}>
              <Route path="/admin/hr/staffs/new" exact element={<UserList />} />
            </Route>
            <Route element={<UserPrivateRoute permission={"readAll-user"} />}>
              <Route path="/admin/hr/staffs" exact element={<GetAllUsers />} />
            </Route>
            <Route element={<UserPrivateRoute permission={"readAll-user"} />}>
              <Route path="/admin/hr/totalSalary" exact element={<GetTotalSalary />} />
            </Route>
            <Route element={<UserPrivateRoute permission={"readAll-user"} />}>
              <Route path="/admin/hr/totalAttendance" exact element={<GetTotalAttendence />} />
            </Route>
            <Route
              element={<UserPrivateRoute permission={"readSingle-user"} />}
            >
              <Route
                path="/admin/hr/staffs/:id"
                exact
                element={<DetailStaff />}
              />
            </Route>
            <Route element={<UserPrivateRoute permission={"create-user"} />}>
              <Route path="/admin/documents" exact element={<UploadDocuments />} />
            </Route>
            <Route
              path="admin/update-document/:id"
              exact
              element={<UpdateDocument />}
            />
            <Route path="/admin/user/documents" element={<UserDocument />} />

            <Route path="/admin/user/documentList" exact element={<UserDocumentList />} />
            <Route
              element={
                <UserPrivateRoute permission={"readAll-rolePermission"} />
              }
            >
              <Route path="/admin/role" exact element={<RoleList />} />
            </Route>
            <Route
              element={
                <UserPrivateRoute permission={"readSingle-rolePermission"} />
              }
            >
              <Route path="/admin/role/:id" element={<DetailRole />} />
            </Route>
            <Route
              element={
                <UserPrivateRoute permission={"create-rolePermission"} />
              }
            >
              <Route
                path="/admin/role/permit/:id/"
                element={<AddPermission />}
              />
            </Route>
            <Route
              element={<UserPrivateRoute permission={"readAll-department"} />}
            >
              <Route path="/admin/department" exact element={<Department />} />
            </Route>
            <Route
              element={
                <UserPrivateRoute permission={"readSingle-department"} />
              }
            >
              <Route
                path="/admin/department/:id"
                element={<DetailDepartment />}
              />
            </Route>
            <Route
              element={<UserPrivateRoute permission={"readAll-designation"} />}
            >
              <Route
                path="/admin/designation"
                exact
                element={<Designation />}
              />
            </Route>


            <Route
              element={
                <UserPrivateRoute permission={"readSingle-designation"} />
              }
            >
              <Route
                path="/admin/designation/:id"
                element={<DetailDesignation />}
              />
            </Route>
            <Route
              element={<UserPrivateRoute permission={"update-designation"} />}
            >
              <Route
                path="/admin/designation/:id/update"
                element={<UpdateDesignation />}
              />
            </Route>
            <Route
              element={<UserPrivateRoute permission={"readAll-setting"} />}
            >
              <Route
                path="/admin/company-setting"
                exact
                element={<CompanyDetails />}
              />
            </Route>
            <Route
              element={<UserPrivateRoute permission={"readAll-setting"} />}
            >
              <Route
                path="/admin/office-area"
                exact
                element={<OfficeAreaSetting />}
              />
            </Route>

            <Route
              element={<UserPrivateRoute permission={"readAll-setting"} />}
            >
              <Route
                path="/admin/salary-components"
                exact
                element={<SalaryComponents />}
              />
            </Route>

            <Route
              element={<UserPrivateRoute permission={"readAll-setting"} />}
            >
              <Route
                path="/admin/salary-templates"
                exact
                element={<SalaryTemplates />}
              />
            </Route>

            {/* === === === Payroll Routes === === === */}
            <Route
              element={<UserPrivateRoute permission={"readAll-payroll"} />}
            >
              <Route path="/admin/payroll/new" element={<CalculatePayroll />} />
              <Route path="/admin/payroll/list" element={<PayslipList />} />
            </Route>
            <Route
              element={<UserPrivateRoute permission={"readSingle-payroll"} />}
            >
              <Route path="/admin/payroll/:id" element={<DetailPayslip />} />
            </Route>

            {/* === === === Shift Routes === === === */}

            <Route element={<UserPrivateRoute permission={"readAll-shift"} />}>
              <Route path="/admin/shift" element={<Shift />} />
            </Route>





            <Route
              element={<UserPrivateRoute permission={"readSingle-shift"} />}
            >
              <Route path="/admin/shift/:id" element={<DetailShift />} />
            </Route>

            {/* === === === EmploymentStatus Routes === === === */}
            <Route
              element={
                <UserPrivateRoute permission={"readAll-employmentStatus"} />
              }
            >
              <Route
                path="/admin/employment-status"
                element={<EmploymentStatus />}
              />
            </Route>

            <Route
              element={
                <UserPrivateRoute permission={"readSingle-employmentStatus"} />
              }
            >
              <Route
                path="/admin/employment-status/:id"
                element={<DetailEmploymentStatus />}
              />
            </Route>

            {/* === === === Leave Routes === === === */}
            <Route path="/admin/leave/:id" element={<DetailLeave />} />

            <Route
              element={
                <UserPrivateRoute permission={"create-leaveApplication"} />
              }
            >
              <Route path="/admin/leave/new" element={<Leave />} />
            </Route>
            <Route
              element={
                <UserPrivateRoute permission={"readAll-leaveApplication"} />
              }
            >
              <Route path="/admin/leave" element={<GetAllLeaves />} />
            </Route>
            <Route
              element={
                <UserPrivateRoute permission={"readSingle-leaveApplication"} />
              }
            >
              <Route path="/admin/leave/user/:id" element={<UserLeave />} />
            </Route>

            <Route path="/admin/allocationLeave" exact element={<AllocatedLeave />} />
            <Route path="/admin/LeaveContradiction" exact element={<LeaveContradiction />} />


            {/* === === === Expense Routes === === === */}

            <Route
              element={
                <UserPrivateRoute permission={"create-leaveApplication"} />
              }
            >
              <Route path="/admin/expense/new" element={<Expense />} />
            </Route>
            <Route
              element={
                <UserPrivateRoute permission={"readAll-leaveApplication"} />
              }
            >
              <Route path="/admin/expense/:id" element={<DetailExpense />} />
              <Route path="/admin/expense" element={<GetAllExpenses />} />
            </Route>
            <Route
              element={
                <UserPrivateRoute permission={"readSingle-leaveApplication"} />
              }
            >
              <Route path="/admin/expense/user/:id" element={<UserExpense />} />
            </Route>


            <Route
              element={
                <UserPrivateRoute permission={"create-leaveApplication"} />
              }
            >
              <Route path="/admin/assets" element={<NewAssets />} />
            </Route>
            {/* === === === Attendance Routes === === === */}
            <Route
              element={<UserPrivateRoute permission={"readAll-attendance"} />}
            >
              <Route path="/admin/attendance" element={<Attendance />} />
              <Route path="/admin/userAttendance" element={<AddUserAttendance />} />
              <Route path="/admin/assets/:id" element={<MyAssets />} />
              <Route path="/admin/assetsStatus" element={<AssetsStatus />} />
              <Route path="/admin/assignAsset" element={<AssignAssetPopup />} />
              <Route path="/admin/attendance/:id" element={<DetailAttendance />} />

            </Route>

            <Route
              element={
                <UserPrivateRoute permission={"readSingle-attendance"} />
              }
            >
              <Route
                path="/admin/attendance/user/:id"
                element={<UserAttendance />}
              />
            </Route>
            {/*<Route
							path='/admin/attendance/:id'
							element={<DetailAttendance />}
						/> */}


            {/* === === === Accounting Routes === === === */}

            <Route
              element={<UserPrivateRoute permission={"readAll-account"} />}
            >
              <Route path="/admin/account" exact element={<Account />} />
              <Route path="/admin/account/:id" element={<DetailAccount />} />
              <Route
                path="/admin/account/trial-balance"
                exact
                element={<TrialBalance />}
              />
              <Route
                path="/admin/account/balance-sheet"
                exact
                element={<BalanceSheet />}
              />
              <Route
                path="/admin/account/income"
                exact
                element={<IncomeStatement />}
              />
            </Route>
            {/* === === === Transaction Routes === === === */}
            <Route
              element={<UserPrivateRoute permission={"readAll-transaction"} />}
            >
              <Route
                path="/admin/transaction"
                exact
                element={<Transaction />}
              />
            </Route>

            <Route
              element={
                <UserPrivateRoute permission={"readSingle-transaction"} />
              }
            >
              <Route
                path="/admin/transaction/:id"
                element={<DetailTransaction />}
              />
            </Route>
            <Route
              element={<UserPrivateRoute permission={"create-transaction"} />}
            >
              <Route
                path="/admin/transaction/create"
                exact
                element={<AddTransaction />}
              />
            </Route>

            {/* === === === Announcement Routes === === === */}
            <Route
              element={<UserPrivateRoute permission={"readAll-announcement"} />}
            >
              <Route
                path="/admin/announcement"
                exact
                element={<Announcement />}
              />
            </Route>

            <Route
              element={
                <UserPrivateRoute permission={"readSingle-announcement"} />
              }
            >
              <Route
                path="/admin/announcement/:id"
                element={<DetailAnnouncement />}
              />
            </Route>

            {/* === === === Award Routes === === === */}

            <Route element={<UserPrivateRoute permission={"create-award"} />}>
              <Route path="/admin/award/new" exact element={<AddAward />} />
            </Route>
            <Route element={<UserPrivateRoute permission={"readAll-award"} />}>
              <Route path="/admin/award/:id" element={<DetailAward />} />
              <Route path="/admin/award" exact element={<GetAllAward />} />
            </Route>

            {/* === === === Leave Policy Routes === === === */}
            <Route
              element={<UserPrivateRoute permission={"readAll-leavePolicy"} />}
            >
              <Route
                path="/admin/leave-policy"
                exact
                element={<LeavePolicy />}
              />
              <Route
                path="/admin/leave-policy/:id"
                element={<DetailLeavePolicy />}
              />
            </Route>

            {/* === === === Weekly Holiday Routes === === === */}
            <Route
              element={
                <UserPrivateRoute permission={"readAll-weeklyHoliday"} />
              }
            >
              <Route
                path="/admin/holiday/week"
                exact
                element={<WeeklyHoliday />}
              />
              <Route
                path="/admin/holiday/week/:id"
                element={<DetailWeeklyHoliday />}
              />
            </Route>

            <Route
              element={
                <UserPrivateRoute permission={"readAll-publicHoliday"} />
              }
            >
              <Route
                path="/admin/dayPartSchedule"
                exact
                element={<DayPartSchedule />}
              />
              <Route
                path="/admin/dayPartSchedule/:id"
                element={<DetailDayHours />}
              />
            </Route>

            {/* === === === Public Holiday Routes === === === */}

            <Route
              element={
                <UserPrivateRoute permission={"readAll-publicHoliday"} />
              }
            >
              <Route
                path="/admin/holiday/public"
                exact
                element={<PublicHoliday />}
              />
              <Route
                path="/admin/holiday/public/:id"
                element={<DetailPublicHoliday />}
              />
            </Route>

            {/* === === === === PROJECT MANAGEMENT STARTED HERE === === === ===*/}

            {/* === === === Kanban Routes === === === */}
            <Route
              element={<UserPrivateRoute permission={"readSingle-project"} />}
            >
              <Route
                path="/admin/kanban/:projectId"
                element={<KanbanBoard2 />}
              />
            </Route>
            {/* <Route
							path='/admin/kanban2/:projectId'
							element={<KanbanBoard2 />}
						/>
 */}
            {/* === === === Project Routes === === === */}
            <Route
              element={<UserPrivateRoute permission={"readAll-project"} />}
            >
              <Route path="/admin/project" element={<Project />} />
            </Route>

            <Route element={<UserPrivateRoute permission={"create-project"} />}>
              <Route path="/admin/project/new" element={<AddProject />} />
            </Route>

            <Route element={<UserPrivateRoute permission={"update-project"} />}>
              <Route
                path="/admin/project/update/:projectId"
                element={<UpdateProject />}
              />
            </Route>

            <Route
              path="/admin/project/update/:projectId/status"
              element={<UpdateStatus />}
            />

            {/* === === === Project Milestone === === === */}

            <Route
              element={<UserPrivateRoute permission={"readAll-project"} />}
            >
              <Route
                path="/admin/project/:id/milestone"
                element={<Milestone isFixed={true} />}
              />
            </Route>

            {/* === === === Project Task Status === === === */}

            <Route
              element={<UserPrivateRoute permission={"readAll-project"} />}
            >
              <Route
                path="/admin/project/:id/task-status"
                element={<TaskStatus isFixed={true} />}
              />
            </Route>
            <Route path="/admin/MyTask" exact element={<MyTask />} />

            {/* === === === Team Routes === === === */}

            <Route
              element={<UserPrivateRoute permission={"readAll-projectTeam"} />}
            >
              <Route path="/admin/team" element={<ProjectTeam />} />
            </Route>

            <Route
              element={
                <UserPrivateRoute permission={"readSingle-projectTeam"} />
              }
            >
              <Route path="/admin/team/:id" element={<DetailProjectTeam />} />
            </Route>
            {/* <Route path='/admin/team/update/:id' element={<DetailProjectTeam />} /> */}

            {/* === === === Milestone Routes === === === */}

            <Route
              element={<UserPrivateRoute permission={"create-milestone"} />}
            >
              <Route path="/admin/milestone" element={<Milestone />} />
            </Route>

            <Route
              element={<UserPrivateRoute permission={"update-milestone"} />}
            >
              <Route
                path="/admin/milestone/update/:id"
                element={<UpdateMilestone />}
              />
            </Route>

            {/* <Route path="/admin/milestone/:id" element={<DetailProject />} /> */}

            <Route element={<UserPrivateRoute permission={"create-task"} />}>
              <Route path="/admin/task" element={<Task />} />
            </Route>

            {/* === === === TaskStatus Routes === === === */}

            <Route
              element={<UserPrivateRoute permission={"readAll-taskStatus"} />}
            >
              <Route path="/admin/task-status" element={<TaskStatus />} />
            </Route>

            <Route
              element={<UserPrivateRoute permission={"update-taskStatus"} />}
            >
              <Route
                path="/admin/task-status/update/:id"
                element={<UpdateTaskStatus />}
              />
            </Route>

            {/* === === === TaskPriority Routes === === === */}

            <Route
              element={<UserPrivateRoute permission={"readAll-priority"} />}
            >
              <Route path="/admin/task-priority" element={<TaskPriority />} />
            </Route>

            <Route
              element={<UserPrivateRoute permission={"update-priority"} />}
            >
              <Route
                path="/admin/task-priority/update/:id"
                element={<UpdateTaskPriority />}
              />
            </Route>

            {/* <Route path='/admin/project-team' eclement={<ProjectTeam />} /> */}

            {/* === === === Task Routes === === === */}
            {/* <Route path="/admin/task" element={<Task />} /> */}
            {/* <Route path="/admin/task/:id" element={<DetailTask />} />  */}

            <Route
              path="/privacy-policy/"
              element={<PrivacyPolicy />}
            >
            </Route>
          </Routes>
        </Main>
      </BrowserRouter>
    </div>
  );
}

export default App;
